<template>
    <b-modal
        v-model="shown"
        centered
        :title="title"
        lazy
    >
        <div>

            <!-- Internal Cost Percentage -->
            <b-form-group>
                <div><label>Internal Cost Contingency Percentage</label></div>
                <b-input-group prepend="%">
                    <b-form-input
                        v-model="internal_cost_percentage"
                        type="number"
                        min="0"
                        step="1"
                    />
                </b-input-group>
            </b-form-group>
            <!--/ Internal Cost Percentage -->

            <!-- Internal Cost Minimum -->
            <b-form-group>
                <div><label>Minimum Internal Cost Contingency</label></div>
                <b-input-group prepend="£">
                    <b-form-input
                        v-model="internal_cost_minimum"
                        type="number"
                        min="0"
                    />
                </b-input-group>
            </b-form-group>
            <!--/ Internal Cost Minimum -->

            <!-- External Price Percentage -->
            <b-form-group>
                <div><label>External Price Contingency Percentage</label></div>
                <b-input-group prepend="%">
                    <b-form-input
                        v-model="external_price_percentage"
                        type="number"
                        min="0"
                        step="1"
                    />
                </b-input-group>
            </b-form-group>
            <!--/ External Price Percentage -->

            <!-- External Price Minimum -->
            <b-form-group>
                <div><label>Minimum External Price Contingency</label></div>
                <b-input-group prepend="£">
                    <b-form-input
                        v-model="external_price_minimum"
                        type="number"
                        min="0"
                    />
                </b-input-group>
            </b-form-group>
            <!--/ External Price Minimum -->

        </div>
        <div slot="modal-footer">
            <b-btn
                variant="default"
                class="mr-2"
                @click="handleClose()"
            >
                Close
            </b-btn>
            <Button
                variant="success"
                :loading="submitLoading"
                @click="handleSubmit()"
            >
                Save
            </Button>
        </div>
    </b-modal>
</template>

<script>
import vueComponentReset from '@ianwalter/vue-component-reset';

const resetMixin = vueComponentReset(() => ({
    shown: false,
    title: '',
    submitLoading: false,
    internal_cost_percentage: '0',
    internal_cost_minimum: '0.00',
    external_price_percentage: '0',
    external_price_minimum: '0.00',
}));

export default {

    mixins: [
        resetMixin,
    ],

    computed: {
        contingency() {
            return this.$store.getters['costable/costable'].contingency;
        },
    },

    created() {
        this.$eventBus.$on(this.$events.openAddContingencyModal, () => {
            this.reset();
            this.title = 'Add Contingency';
            this.shown = true;
        });
        this.$eventBus.$on(this.$events.openEditContingencyModal, () => {
            this.reset();
            this.internal_cost_percentage = this.contingency.internal_cost_percentage;
            this.internal_cost_minimum = this.contingency.internal_cost_minimum;
            this.external_price_percentage = this.contingency.external_price_percentage;
            this.external_price_minimum = this.contingency.external_price_minimum;
            this.title = 'Edit Contingency';
            this.shown = true;
        });
    },

    methods: {
        async handleSubmit() {
            this.submitLoading = true;
            await this.$store.dispatch('costable/updateContingency', {
                internalCostPercentage: this.internal_cost_percentage,
                internalCostMinimum: this.internal_cost_minimum,
                externalPricePercentage: this.external_price_percentage,
                externalPriceMinimum: this.external_price_minimum,
            });
            this.submitLoading = false;
            this.handleClose();
        },
        handleClose() {
            this.shown = false;
        },
    },

};
</script>
